import './modalreceipt.scss';

import { FunctionComponent } from "react";
import { useAppSelector } from '../../../../features';
import { getReceiptData } from '../../../../store/ReceiptSlice';
import { Amount } from '../../amount/amount';
import { formatDatePtBr, textFormatterWalletHiddenChars } from '../../../../utils/textFormatter';
import { QRCodeSVG } from 'qrcode.react';
import { withdrawalReceipt } from '../../../../types/transactions';

const withdrawalStatusLabel = (s:string) => {
    let label = "Saque";
    if(s === 'done') label = "Transferencia Realizada"
    if(s === 'waiting-offer') label = "em processo"
    return label;
}

const networkLabel = (s:string) => {
    let label = "BlockChain";
    if(s === 'ethereum-chain') label = "Ethereum Blockchain"
    return label;
}

export const WithdrawalReceipt: FunctionComponent = () => {
    
    const receiptInfo   : withdrawalReceipt      = useAppSelector(getReceiptData) as withdrawalReceipt;
    
    return (
        <div className="modal-body withdrawal">
            <h1>
                    Recibo de Saque <br/>
                    <small>#{receiptInfo?.data?.id}</small>
            </h1>

            <ul>
                <li>
                    <span>Carteira Destino</span>
                    <span>
                        {textFormatterWalletHiddenChars(receiptInfo?.data?.payee,10)}
                    </span>
                </li>
                <li>
                    <span>Valor</span>
                    <span>
                        <Amount 
                            value={receiptInfo?.data?.amount} 
                            format={false} 
                            currency={'USDT'}
                            isReceipt = {true}/>
                    </span>
                </li>
                <li>
                    <span>Criação do Pedido do Saque</span>
                    <span>
                        {formatDatePtBr(receiptInfo?.data?.created_at)}
                    </span>
                </li>
                <li>
                    <span>Execução do Pedido do Saque</span>
                    <span>
                        {formatDatePtBr(receiptInfo?.data?.delivered_at)}
                    </span>
                </li>
                <li>
                    <span>Rede</span>
                    <span className="small">{networkLabel(receiptInfo?.data?.system_currency)}</span>
                </li>
                <li>
                    <span>Status</span>
                    <span className="small label">{withdrawalStatusLabel(receiptInfo?.data?.status)}</span>
                </li>
            </ul>

            <div className="qrcode">
                <QRCodeSVG value={"http://www.uol.com.br"} />
            </div>
        </div>
    )
}